<template>
  <div>
    <table class="table table-striped">
      <thead class="bg-hub-primary text-white">
        <tr>
          <th>Name</th>
          <th class="d-none d-md-table-cell">Devices/Zones</th>
          <th v-if="type !== 'visual'">Extension</th>
          <th class="d-none d-md-table-cell">Color</th>
          <th>Manage</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="zone in filtered_zones" :key="zone.zone_id">
          <td>{{ zone.name }}</td>
          <td
            class="d-none d-md-table-cell"
            v-if="zone.zone_devices.length > 0 || zone.zone_zones.length > 0"
          >
            <button
              type="button"
              class="btn btn-light"
              @click="toggle_devices(zone.zone_id)"
            >{{ ((zones_showing_devices.includes(zone.zone_id)) ? 'Hide' : 'Show') }} {{ hasDevices(zone) ? 'Devices' : 'Zones' }}</button>
            <div v-if="zones_showing_devices.includes(zone.zone_id)">
              <br />
              <table class="table">
                <tbody v-if="hasDevices(zone)">
                  <tr v-for="zone_device in zone.zone_devices" :key="zone_device.zone_device_id">
                    <td>
                      <span v-if="zone.site_id === 1">[{{ zone_device.device.site.name }}]</span>
                      {{ zone_device.device.name }}
                      <span
                        v-if="isSip(zone_device.device)"
                      >(Ext: {{ zone_device.device.extension }})</span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else-if="isZoneZone(zone)">
                  <tr v-for="zone_zone in zone.zone_zones" :key="zone_zone.zone_zone_id">
                    <td>
                      <span v-if="zone.site_id === 1">[{{ zone_zone.child_zone.site.name }}]</span>
                      {{ zone_zone.child_zone.name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
          <td class="d-none d-md-table-cell" v-else>
            <span v-if="hasDevices(zone)">No devices assigned</span>
            <span v-if="isZoneZone(zone)">No zones assigned</span>
          </td>
          <td v-if="type !== 'visual'">
            <span v-if="zone.extension !== '0'">{{ zone.extension }}</span>
            <span v-else>N/A</span>
          </td>
          <td class="d-none d-md-table-cell">
            <div class="keyImage">
              <div
                class="keyFilter"
                v-bind:style="{ backgroundColor: zone.color, 'border-radius': '80%' }"
              ></div>
            </div>
          </td>
          <td>
            <div class="dropdown">
              <button
                class="btn btn-light dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <router-link
                  :to="{ name:'ZoneManagerEdit', params: { zone_id: zone.zone_id } }"
                  class="dropdown-item"
                >
                  <i class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i>&nbsp;Edit
                </router-link>
                <a class="dropdown-item" href="#" onclick="return false" @click="deleteZone(zone)">
                  <i class="fa fa-trash fa-fw" aria-hidden="true"></i>&nbsp;Delete
                </a>
                <div class="dropdown-divider"></div>
                <router-link
                  :to="{ name: 'ZoneManagerAssignDevices', params: { zone_id: zone.zone_id }}"
                  class="dropdown-item"
                  v-if="hasDevices(zone)"
                >
                  <i class="fa fa-list fa-fw" aria-hidden="true"></i> Assign Devices
                </router-link>
                <router-link
                  :to="{ name: 'ZoneManagerAssignZones', params: { zone_id: zone.zone_id }}"
                  class="dropdown-item"
                  v-if="isZoneZone(zone)"
                >
                  <i class="fa fa-list fa-fw" aria-hidden="true"></i> Assign Zones
                </router-link>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DEVICE_TYPE, ZONE_TYPE } from '../../assets/js/resource-types'

export default {
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      zones_showing_devices: []
    }
  },
  computed: {
    ...mapGetters({
      scoped_site_id: 'scopedSiteId',
      zones: 'allZones'
    }),
    filtered_zones: function () {
      let zoneTypes = []

      if (this.type === 'main') {
        zoneTypes = [ZONE_TYPE.Devices, ZONE_TYPE.Zones, ZONE_TYPE.Visual, 5]
      } else if (this.type === 'multicast') {
        zoneTypes.push(ZONE_TYPE.Multicast)
      }

      return this.zones.filter(
        zone =>
          zone.site_id === this.scoped_site_id &&
          zoneTypes.includes(zone.zone_type_id)
      )
    }
  },
  created () {
    this.$store.dispatch('getZones')
  },
  methods: {
    ...mapActions(['deleteZone']),
    isSip(device) {
      return device.device_type_id === DEVICE_TYPE.SIP
    },
    toggle_devices (zoneId) {
      if (this.zones_showing_devices.includes(zoneId)) {
        this.zones_showing_devices.splice(
          this.zones_showing_devices.indexOf(zoneId),
          1
        )
      } else {
        this.zones_showing_devices.push(zoneId)
      }
    },
    isZoneZone(zone) {
      return zone.zone_type_id === ZONE_TYPE.Zones
    },
    hasDevices(zone) {
      return [
        ZONE_TYPE.Devices,
        ZONE_TYPE.Visual,
        5
      ].includes(zone.zone_type_id)
    },
  }
}
</script>

<style scoped>
</style>
